import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'bills-list',
    templateUrl: '../../templates/partials/list-bills.html'
})

export class ListBillsComponent implements OnInit {

    @Input() bills;
    public page = 1;
    @Input() paid = null;
    public showPage = true;
    @Input() type;
    constructor(private router: Router) { }

    public goDetail(id: number){
        //console.log(this.type);
        this.type = this.type.trim();
        this.router.navigate(['/bills/'+ this.type, id]);
    }

    public downloadBill(id: number){}

    public sendBill(id:number){}

    ngOnChanges(changes: any) {
        if(this.bills.length <= (this.page * 20)){
            this.showPage = false;
        }else{
            this.showPage = true;
        }
        if(changes.paid){
            if(!changes.paid.firstChange){
                this.page = 1;
            }
        }
    }

    public addPage(){
        this.page++;
        if(this.bills.length <= (this.page * 20)){
            this.showPage = false;
        }
    }

    ngOnInit() { 
        
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/list-bills.component.ts